module.exports = __webpack_public_path__ + "media/images/index/area/faeture_kansai-e58bccb37cc75218d9bc2691b87f776e.png";